import ApiService from '@/services/ApiService';

const namespace = 'projects';

const find = (id, options, callback, errorCallback) => {
    ApiService.get(`${namespace}/${id}`, options, callback, errorCallback);
};

const findAll = (options, callback, errorCallback) => {
    ApiService.get(namespace, options, callback, errorCallback);
};

const count = (options, callback, errorCallback) => {
    ApiService.get(`${namespace}/count`, options, callback, errorCallback);
};

const sumByDatePeriod = (options, callback, errorCallback) => {
    ApiService.get(`${namespace}/sum-by-date-period`, options, callback, errorCallback);
};

const value = (options, callback, errorCallback) => {
    ApiService.get(`${namespace}/value`, options, callback, errorCallback);
};

const create = (options, callback, errorCallback) => {
    ApiService.post(namespace, options, callback, errorCallback);
};

const update = (id, options, callback, errorCallback) => {
    ApiService.put(`${namespace}/${id}`, options, callback, errorCallback);
};
const updateNotes = (id, options, callback, errorCallback) => {
    ApiService.put(`${namespace}/${id}/notes`, options, callback, errorCallback);
};

const remove = (id, callback, errorCallback) => {
    ApiService.remove(`${namespace}/${id}`, callback, errorCallback);
};

const cancelProject = (id, options, callback, errorCallback = null) => {
    ApiService.post(`${namespace}/${id}/cancel`, options, callback, errorCallback);
};

const postProjectClarification = (id, callback, errorCallback) => {
    ApiService.post(`${namespace}/${id}/clarify`, callback, errorCallback);
};

const postPriceOffer = (id, callback, errorCallback) => {
    ApiService.post(`${namespace}/${id}/priceOffer`, callback, errorCallback);
};

const acceptPriceOffer = (id, callback, errorCallback) => {
    ApiService.post(`${namespace}/${id}/acceptPriceOffer`, callback, errorCallback);
};

const finalize = (id, callback, errorCallback) => {
    ApiService.post(`${namespace}/${id}/finalize`, callback, errorCallback);
};
const files = (id, callback, errorCallback) => {
    ApiService.get(`${namespace}/${id}/files`, callback, errorCallback);
};

export default {
    find,
    findAll,
    count,
    sumByDatePeriod,
    value,
    create,
    update,
    updateNotes,
    remove,
    cancelProject,
    postProjectClarification,
    postPriceOffer,
    acceptPriceOffer,
    finalize,
    files
};



// WEBPACK FOOTER //
// ./src/taskflex/projects/services/ProjectService.js